module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-narrow-left-column SectionBorderTop"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('CalendarIcon', {
    staticClass: "calendarIcon",
    attrs: {
      "color": '#d8d9d4'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('DateInfosDetail', {
    attrs: {
      "forecast": _vm.forecast,
      "forecast-window": _vm.forecastWindow
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6357d6f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/CalendarInfo.vue
// module id = 3228
// module chunks = 0